import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  ul li {
    width: 100%;
    min-width: 280px;
    @media (max-width: 1200px) {
      min-width: 250px;
      max-width: 500px;
    }
  }

  ul {
    padding-right: 24px;
    width: 250px;
  }

  @media (max-width: 1200px) {
    width: 100%;
    min-width: 230px;
    overflow-y: hidden;
  }
`;

export const BPListWrapper = styled.div<{ isListOpen: boolean }>`
  width: 100%;
  border-radius: 8px;
  overflow-y: auto;

  @media (max-width: 1200px) {
    overflow-y: auto;
    height: calc(100vh - 120px);
  }

  h3 {
    color: ${({ isListOpen }) =>
      isListOpen ? customPalette.accent.white : '#000000'};
  }

  button {
    margin: 10px 0;
  }

  .MuiTextField-root {
    width: 100%;
    margin-bottom: 16px;
    border-radius: 4px;
    border: 1px solid #ccc;
    box-sizing: border-box;
  }

  ul {
    list-style: none;
    padding: 0;
    overflow-y: hidden;
    height: 100%;
    width: 100%;
  }
`;

export const ActiveBPWrapper = styled.div`
  color: ${customPalette.accent.white};
  border-radius: 8px;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;

  h3 {
    margin: 0;
  }

  @media (max-width: 1200px) {
    padding: 8px;
    height: 100%;
  }
`;

export const BPDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: ${customPalette.accent.white};
  padding-left: 12px;
  flex: 1;

  .bp-number {
    font-weight: bold;
  }

  .bp-name {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 100px;
  }

  @media (max-width: 1200px) {
    padding-left: 8px;
  }
`;

export const BPItem = styled.li`
  padding: 12px 8px;
  margin: 8px 0;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${customPalette.accent.main};
  color: ${customPalette.accent.white};
  display: flex;
  align-items: center;
  width: 100%;

  @media (max-width: 1200px) {
    padding-left: 8px;
    width: 100%;
    max-width: 250px;
  }
`;

export const IconWrapper = styled.div`
  flex: 0 0 20%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1200px) {
    justify-content: flex-start;
    margin-right: 8px;
  }
`;

export const ArrowIconWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 0 0 auto;

  button {
    color: ${customPalette.accent.white};
  }

  @media (max-width: 1200px) {
    display: none;
  }
`;

export const EndAoBWrapper = styled.div`
  width: 100%;
  margin-top: 10px;
`;

export const StyledLoaderWrapper = styled.div`
  width: 100%;
`;

export const FullWidthDiv = styled.div`
  width: 100%;
`;
